import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])
    return (


        <div class="wrapper dashboard_page ">
            <div class=" page-body d-flex align-items-stretch">
                <div class="page-content mx-auto">
                    <div className="page_wrapper" >
                        <div className="container container-custom" >
                                <main>
                                    <section className="error_page login_bg login_sec text-center">
                                        <img src="/assets/images/404.svg" className="img-fluid" alt="" />
                                        <Link to="/dashboard" className="btn btn-warning" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                            <i className="ri-home-2-line me-2"></i> Back to Home
                                        </Link>
                                    </section>
                                </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default ErrorPage